import React from 'react';

import { Outlet, useLocation } from 'react-router';
import BottomNavbar from './Navbar/BottomNavbar/BottomNavbar';
import Navbar from './Navbar/Navbar';
import { useViewport } from "../CustomHooks/useViewport";
export default () => {
    const { width } = useViewport();
    const breakpoint = 600;

    const location = useLocation()
    return (
        <>
            <Navbar />
            {(width < breakpoint) && !location.pathname.includes('short/') ? <BottomNavbar /> : ''}
            <Outlet />
        </>
    );
};